import {
  DashboardModule, Form,
} from '@domain-group/suit-theme'

import { UseFormPayload } from '@domain-group/react-hooks'

interface BrandFormPayloadProps {
  brandFormPayload: UseFormPayload,
}

const BrandDetails = (props: BrandFormPayloadProps) => {
  const { brandFormPayload } = props || {}
  const {
    entityState: {
      business_name,
      email,
      phone,
      title,
      website,
    },
    errors,
    handlers,
  } = brandFormPayload

  return (
    <DashboardModule title="Brand Details">
      <Form padding="large">
        <Form.Row>
          <Form.Field errorMessage={errors.title} label="* Title">
            <input name="title" value={title} type="text" {...handlers} />
          </Form.Field>

          {/*
           // @ts-expect-error TS2322 */}
          <Form.Field label="Business Name" marginTop={['large', 0]}>
            <input name="business_name" value={business_name} type="text" {...handlers} />
          </Form.Field>

          <Form.Field errorMessage={errors.phone} label="* Phone" marginTop="large">
            <input name="phone" type="text" value={phone} {...handlers} />
          </Form.Field>

          <Form.Field errorMessage={errors.email} label="* Email" marginTop="large">
            <input name="email" value={email} type="email" {...handlers} />
          </Form.Field>

          <Form.Field errorMessage={errors.website} label="* Website" marginTop="large">
            <input name="website" value={website} type="text" {...handlers} />
          </Form.Field>
        </Form.Row>
      </Form>
    </DashboardModule>
  )
}

export default BrandDetails
